import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { TestSubsection } from "./TestSection";
import { LogIn, Shield, UserPlus } from "lucide-react";
import * as tests from "./testDefinitions";

export const AuthFlowsSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">🔐 Authentication Flows</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={LogIn}
          iconColor="text-emerald-600"
          title="Owner Sign-In"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.ownerSigninTests}
          results={testResults.ownerSignin}
        />
        
        <TestSubsection
          icon={Shield}
          iconColor="text-indigo-600"
          title="Team Member Sign-In"
          tests={tests.teamSigninTests}
          results={testResults.teamSignin}
        />
        
        <TestSubsection
          icon={UserPlus}
          iconColor="text-blue-600"
          title="Org Signup Flow"
          tests={tests.signupTests}
          results={testResults.signup}
        />
      </CardContent>
    </Card>
  );
};
